export default function (state = false, action) {
  switch (action.type) {
    case "IS_EXPERT":
      return action.payload;
      break;
    default:
      return state;
  }
}
